import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";

/**
 * TABLE LEAGUEREGIONS
 */
function LeagueRegions() {
  return (
    <Crud
      title="League Regions"
      getUrl={() => "/Game/LeagueRegion_GetList"}
      // INSERT
      insertUrl={() => "/Game/LeagueRegion_Insert"}
      insertParams={({ userId }, { description, regionOrder }) => ({
        Description: description,
        RegionOrder: regionOrder,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/Game/LeagueRegion_Update"}
      updateParams={(
        { userId },
        { idLeagueRegion, description, regionOrder }
      ) => ({
        IdLeagueRegion: idLeagueRegion,
        Description: description,
        RegionOrder: regionOrder,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/Game/LeagueRegion_Delete"}
      deleteParams={({ userId }, id) => ({
        IdLeagueRegion: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idLeagueRegion"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn dataField="regionOrder">Order</TableHeaderColumn>
      <TableHeaderColumn dataField="description">Description</TableHeaderColumn>
    </Crud>
  );
}

export default LeagueRegions;
